"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Users, CheckCircle, Heart, Lightbulb } from "lucide-react";
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const reasons = [{
    title: "Expert Team",
    description: "Our dedicated professionals bring years of experience to deliver exceptional results tailored to your business needs.",
    icon: <Users className="w-8 h-8 text-[#f97a00]" />
  }, {
    title: "Quality Driven",
    description: "We maintain the highest standards of quality in every project, ensuring reliability, durability, and excellence.",
    icon: <CheckCircle className="w-8 h-8 text-[#f97a00]" />
  }, {
    title: "Customer Focus",
    description: "Your success is our priority. We listen to your needs and adapt our strategies to help you achieve your goals.",
    icon: <Heart className="w-8 h-8 text-[#f97a00]" />
  }, {
    title: "Innovative Solutions",
    description: "We leverage cutting-edge technology and creative strategies to keep you ahead of the competition.",
    icon: <Lightbulb className="w-8 h-8 text-[#f97a00]" />
  }];
  return;
}